import * as React from "react";
import Dialog from '@mui/material/Dialog';
import DialogContent from '@mui/material/DialogContent';
import DialogTitle from '@mui/material/DialogTitle';
import IconButton from '@mui/material/IconButton';
import CloseIcon from '@mui/icons-material/Close';

export const FullScreenModal = ({
  onClose = () => {},
  children,
  preventBackdropClick = false,
  title
}) => {
  const [open, setOpen] = React.useState(true);
  const handleClose = (event, reason) => {
    if (reason === "backdropClick" && preventBackdropClick === true) {
      return false;
    }
    setOpen(false);
    onClose();
  };
  return (
    <Dialog
      open={open}
      onClose={handleClose}>
        <DialogTitle sx={{ m: 0, p: 0 }} id="customized-dialog-title">
          {title}
        </DialogTitle>
        <IconButton
          aria-label="close"
          onClick={handleClose}
          sx={(theme) => ({
            position: 'absolute',
            right: 8,
            top: 15,
            color: '#001b66',
          })}
        >
          <CloseIcon />
        </IconButton>
        <DialogContent>
          {children}
        </DialogContent>
      </Dialog>
  );
};
